import { useTranslation } from 'react-i18next';
import { colors } from 'components/styles/variables';

export default function PhotoDisclaimer(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="container">
      <span>
        {t('legalDisclaimers.izmoCredits', {
          year: new Date().getFullYear(),
        })}
      </span>
      <style jsx>{`
        .container {
          font-size: 16px;
          color: ${colors.G4};
          padding: 16px 24px;
          margin-top: 72px;
        }
      `}</style>
    </div>
  );
}
